"use strict";
var STUDYPROGRAMS = "studyPrograms";
var PREFERENCE = "preference";
var SAT_PREP = "nav-sat-prep-24";
var ACT_PREP = "naviance-act-2025-prep";
var SUCCESS_MESSAGE_KEY = "successMessage";
var MESSAGE_KEY = "manageDefaults";
var ManageDefaultsController = (function () {
    /* @ngInject */
    function ManageDefaultsController($route, $location, userSessionService, groupsService, studyProgramsService, $rootScope, messagingService, FEATURE_TOGGLE) {
        var _this = this;
        this.$route = $route;
        this.$location = $location;
        this.userSessionService = userSessionService;
        this.groupsService = groupsService;
        this.studyProgramsService = studyProgramsService;
        this.$rootScope = $rootScope;
        this.messagingService = messagingService;
        this.FEATURE_TOGGLE = FEATURE_TOGGLE;
        this.districtManagedDefaultGroups = false;
        this.showActPrep = false;
        this.showSatPrep = false;
        this.showError = false;
        this.showManageDefaultAlert = false;
        this.goHome = function () {
            _this.$location.path("/" + _this.tenantId);
        };
        this.toggleChange = function (name, value) { _this[name] = value; };
        this.errorCallback = function () {
            _this.$rootScope.loadingError = true;
            _this.$rootScope.loadingView = false;
        };
        this.handleResponse = function (status) {
            if (status < 400) {
                _this.$rootScope.successMessage = _this.messagingService(MESSAGE_KEY)[SUCCESS_MESSAGE_KEY];
                _this.studyProgramsService.clearStudyProgramsCache();
                _this.$location.path(_this.crumbs[0].url);
            }
            else {
                _this.errorCallback();
            }
        };
    }
    ManageDefaultsController.prototype.$onInit = function () {
        var studyPrograms = this.$route.current.locals[STUDYPROGRAMS];
        this.district = this.userSessionService.isDistrictMode();
        if (this.district) {
            this.tenantId = this.userSessionService.getDistrictTenantId();
        }
        else {
            this.tenantId = this.$route.current.params.tenantId;
        }
        this.updateCrumbs();
        this.preferenceData = this.$route.current.locals[PREFERENCE];
        this.getStudyProgramList(studyPrograms);
        if (this.preferenceData) {
            this.showAlertMessage();
        }
    };
    ManageDefaultsController.prototype.showAlertMessage = function () {
        if (this.preferenceData && this.preferenceData.preferences) {
            var preferences = this.preferenceData.preferences;
            this.actPrep = preferences.act || false;
            this.satPrep = preferences.sat || false;
            this.districtManagedDefaultGroups = preferences.districtManagedDefaultGroups;
            var seenAlertMessage = preferences.seenManageDefaultAlertMessage;
            if ((this.actPrep || this.satPrep) && !seenAlertMessage) {
                this.showManageDefaultAlert = true;
                this.actPrep = false;
                this.satPrep = false;
            }
        }
    };
    ManageDefaultsController.prototype.dismissAlertMessage = function () { this.showManageDefaultAlert = false; };
    ManageDefaultsController.prototype.showDefaultsTable = function () { return !this.district || this.districtManagedDefaultGroups; };
    ManageDefaultsController.prototype.submit = function () {
        var data = {
            districtManagedDefaultGroups: this.districtManagedDefaultGroups,
            actPrepDefault: this.actPrep,
            satPrepDefault: this.satPrep
        };
        this.$rootScope.loadingView = true;
        this.groupsService.updateDefaultGroupPreferences(this.tenantId, data).then(this.handleResponse, this.errorCallback);
    };
    ManageDefaultsController.prototype.updateCrumbs = function () {
        if (this.district) {
            this.crumbs = [
                { name: "Naviance Test Prep: District", url: "" + this.tenantId },
                { name: "Manage Default Study Programs" }
            ];
        }
        else {
            this.crumbs = [
                { name: "Naviance Test Prep", url: "" + this.tenantId },
                { name: "Manage Default Study Programs" }
            ];
        }
    };
    ManageDefaultsController.prototype.getStudyProgramList = function (studyPrograms) {
        var _this = this;
        // TODO this method will likely change current default preferences become available
        studyPrograms.forEach(function (program) {
            if (program.courseSlug === ACT_PREP) {
                _this.showActPrep = true;
            }
            if (program.courseSlug === SAT_PREP) {
                _this.showSatPrep = true;
            }
        });
    };
    return ManageDefaultsController;
}());
exports.ManageDefaultsController = ManageDefaultsController;



/** WEBPACK FOOTER **
 ** ./app/manage-defaults/manage-defaults.controller.ts
 **/